import { Container } from '@mui/material';

import { DrawerActionsPorps } from './types';

export default function DrawerActions({
  children,
  isFixed = true
}: DrawerActionsPorps) {
  return (
    <Container
      sx={{
        position: 'absolute',
        marginLeft: '-24px',
        marginTop: '16px',
        background: 'white',
        zIndex: 2,
        // todo: replace this hard coded value to match what is in the Page `drawerWidth`
        width: '360px',
        p: 2,
        display: 'flex',
        gap: 1,
        alignContent: 'space-between',
        '> button': {
          fontWeight: 700,
          fontSize: 12,
          ':hover': {
            cursor: 'pointer'
          },
          minWidth: 'fit-content',
          width: '100%'
        }
      }}
      disableGutters
    >
      {children}
    </Container>
  );
}
